export const initialState = {
  user: null,
};

export const getUser = (state = initialState) => state.user || initialState.user;
export const getExpiresAt = (state = initialState) =>
  state.user ? state.user.expiresAt : initialState.user;
export const getToken = (state = initialState) =>
  state.user ? state.user.token : initialState.user;
export const getEmail = (state = initialState) => (state.user ? state.user.email : '');
